module.exports = __webpack_public_path__ + "img/set cortesia 2.2034f645.jpeg";